<template>
  <transition name="fade">
    <div
      class="higo-toast"
      v-show="visible&&message">
      {{ message }}
    </div>
  </transition>
</template>
<script>
import { duration } from './constant.js'
export default {
  name: 'HigoToast',
  props: {

  },
  mixins: [ ],
  data () {
    return {
      message: '',
      duration,
      visible: false
    }
  },
  created () {

  },
  mounted () {
    this.createTimer()
  },
  destroyed () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      clearTimeout(this.timer)
    },
    createTimer () {
      this.timer = setTimeout(() => {
        this.visible = false
      }, this.duration)
    }
  }
}
</script>
<style lang="scss" scoped>

.higo-toast{
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate3d(-50%,-50%,0);
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 8px;
  padding: 20px 33px;
  z-index:2000;
  text-align: center;
  line-height: 40px;
  font-size: 24px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>
